import React, { useEffect } from 'react'
import * as Sentry from '@sentry/node'
import PageNotFound from '../components/default/PageNotFound'

// Shamelessly inspired from:
// https://leerob.io/blog/configuring-sentry-for-nextjs-apps

const ErrorPage = ({ statusCode, hasGetInitialPropsRun, err }) => {
  if (!hasGetInitialPropsRun && err) {
    Sentry.captureException(err);
  }
  return (
    <PageNotFound />
  )
}

ErrorPage.getInitialProps = async ({ res, err, asPath }) => {
  if (res?.statusCode === 404) {
    return { statusCode: 404 };
  }
  if (err) {
    Sentry.captureException(err)
    await Sentry.flush(2000)
  }

  return {
    hasGetInitialPropsRun: true
  };
}

export default ErrorPage
